import { CalendlyIntegrationHandler } from "./calendly";
import { ZenDeskORFreshDeskIntegrationHandler } from "./zendesk";

import { DefaultIntegrationHandler, IntegrationHandler } from ".";

export enum IntegrationType {
  CALENDLY = "calendly",
  CALENDAR = "calendar",
  WHATSAPP = "whatsapp",
  MESSENGER = "messenger",
  SLACK = "slack",
  TELEGRAM = "telegram",
  ZENDESK = "zendesk",
  FRESHDESK = "freshdesk",
}

export function getIntegrationConfiguration({
  type,
  data,
}: {
  type: IntegrationType;
  data: IntegrationHandler;
}) {
  switch (type) {
    case IntegrationType.CALENDLY:
      return new CalendlyIntegrationHandler(data);
    case IntegrationType.ZENDESK:
      return new ZenDeskORFreshDeskIntegrationHandler(data);
    case IntegrationType.FRESHDESK:
      return new ZenDeskORFreshDeskIntegrationHandler(data);
    default:
      return new DefaultIntegrationHandler(data);
  }
}